<template>
  <v-flex xs12 row>
    <v-layout row wrap>
      <v-flex xs12>
        
      </v-flex>
    </v-layout>

  <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-text-field v-model="filter.title" label="Item Name" class="mr-3"></v-text-field>
            <v-text-field v-model="filter.code" label="Item Code" class="mr-3"></v-text-field>
            <autocomplete label="Search Branch" sub-title="mobile" v-model="filter.retailer" async api-path="retailer-search" clearable />
            <search-btn @click="filterData" />
            
            <v-spacer></v-spacer>

          </v-card-title>
          
          <data-table
            :headers="$options.headers"
            :items="processedItems"
            :loading="processing"
            :title="resultTitle"
            :sheet-name="today('DD-MM-YYYY')"
            hide-actions
            download
          ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>

  import DataTable from '../../components/DataTable'

  export default {
    
    components: {
      'data-table': DataTable,
    },

    data () {
      return {
        title: "Branch Stok Report",
        processing: false,
        items: [],
        filter: {
          title: "",
          code: "",
          retailer: ""
        },
      }
    },

    created () {
        let breadcrumbs = [
          {
            text: 'Dashboard',
            disabled: false,
            href: '/dashboard'
          },
          {
            text: 'Branches',
            disabled: false,
            href: '/branches'
          },
          {
            text: 'Stock Report',
            disabled: true
          }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Branch Stock')

      this.$options.headers = [
        { text: 'Item', value: 'item_name', sortable: false },
        { text: 'Code', value: 'item_code', sortable: false },
        { text: 'Branch', value: 'retailer_name', sortable: false },
        { text: 'Unit', value: 'unit_name', sortable: false },
        { text: 'Parent', value: 'is_parent', sortable: false },
        { text: 'Stock QTY', value: 'stock_quantity', align: 'right', sortable: false }
      ]

    },
    methods: {

      loadPage () {

        if (!this.filter.retailer) return

        let api_path = this.config.apis.reports.retailer

        let filterArray = [ "type=inline" ]

        for (const [key, val] of Object.entries(this.filter)) {
          if (val) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '?' + filterArray.join('&')
        }
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.items = response.data.data
            }
            else{
              this.items = []
            }
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },

    computed: {
      
      processedItems() {
          
        return this.items.map(item => {
          return {
            item_name: item.item_name,
            item_code: item.item_code,
            retailer_name: item.retailer_name,
            unit_name: item.unit_name,
            is_parent: item.is_parent ? 'Parent' : '-',
            stock_quantity: item.stock_quantity,
          }
        })
        
      },

      resultTitle () {
        return `${this.title}_${this.today('DD-MM-YYYY')}`
      },

    },

  }
</script>
